class BxfDialogConstants {
    static STRING = {
        BXF_DIALOG: 'bxf-dialog',
        HEADING_LABEL: 'bxf-dialog-heading',
        CONTENT_LABEL: 'bxf-dialog-content',
        HEADER_CONTENT_CONTAINER: 'bxf-dialog__header-content-container',
        HEADER: 'bxf-dialog__header',
        FOOTER: 'bxf-dialog__footer',
        OVERLAY: 'bxf-dialog__overlay',
        CONTENT_CONTAINER: 'bxf-dialog__content-container',
        HEADER_COMPACT: 'bxf-dialog__header--compact',
        CONTENT: 'bxf-dialog__content',
        CONTENT_PADDING: 'bxf-dialog__content--padding',
        CONTENT_PADDING_COMPACT: 'bxf-dialog__content-padding--compact',
    };
}

export { BxfDialogConstants as B };
